import * as yup from "yup"

export const cleanSIREN = (spacedSIREN: string): string =>
  spacedSIREN.replace(/\s/g, "")

export const validateAPE = (testedAPE: string): boolean =>
  testedAPE.startsWith("69.2")

export const validateSIREN = (testedSIREN: string): boolean =>
  /^(?:[0-9]{9}|[0-9]{14})$/.test(cleanSIREN(testedSIREN))

const regexSirenFormat = new RegExp(`^(?:[0-9]{9}|[0-9]{14})$`)

export const sirenSchema = yup.object({
  siren: yup
    .string()
    .transform(cleanSIREN)
    .min(9, "length")
    .max(14, "length")
    .matches(regexSirenFormat, "format")
    .required(),
})

export function validateSIRENSync(sirenValue: string) {
  try {
    const data = { siren: sirenValue }

    sirenSchema.validateSync(data, { abortEarly: false })
    return { isValid: true, errors: null }
  } catch (err) {
    return { isValid: false, errors: (err as { errors: string }).errors }
  }
}

export type SirenStatus =
  | null
  | "not found"
  | "taken fiduciary"
  | "ok"
  | "bad APE"
  | "hidden" // société non diffusable

export interface SirenCheckResponseType {
  name: string
  address: string
  postal_code: string
  city: string
  hidden?: boolean
  siren: string
  code_ape: string
  sirenState: null
  ape_details: string
  country: string
  country_code: string
  full_legal_form: string
  legal_form: string
  max_work_force: number
  min_work_force: number
  share_capital: string | null
  siege_siret: string
  vat_number: string | null
  work_force: string
}
